import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import confirmationDialogStyles from './confirmationDialog.module.css';

const styles = (theme: Theme) =>

  createStyles({
    btn: {
      margin: '10px 10px'
    },
    ex: {
      padding: 0
    },
    button: {
      height: '50px',
      marginTop: '14px'
    }
  });

interface ConfirmationDialogProps {
  classes: any;
  open: boolean;
  title: string;
  text: string | JSX.Element;
  close: () => void;
  confirm: () => void;
  textConfirm: string;
  showCloseIcon: boolean;
  textCancel?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  showCancelButton?: boolean;
};

const confirmationDialog = (props: ConfirmationDialogProps) => {
  
  const { classes } = props;

  return (
    <Dialog
      open={props.open}
      maxWidth={props.maxWidth}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className={ confirmationDialogStyles.flex }>
        <DialogTitle id="alert-dialog-title">{ props.title }</DialogTitle>
        { props.showCloseIcon &&
          <IconButton aria-label="Close" onClick={ props.close } className={ classes.button }>
            <CloseIcon className={ classes.ex } color='primary' />
          </IconButton>
        }
      </div>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">{ props.text }</DialogContentText>
      </DialogContent>

      <DialogActions>
        { props.showCancelButton &&
          <Button className={ classes.btn } onClick={ props.close } variant="contained">{ props.textCancel || "Cancel" }</Button>
        }
        <Button
          className={ classes.btn }
          onClick={() => {
            if (props.confirm) {
              props.confirm();
            }
            props.close();
          }}
          color='primary'
          variant="contained"
        >
          { props.textConfirm }
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default withStyles(styles)(confirmationDialog);